import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchLocation = ({ onSearch, suggestions }) => {
  const [query, setQuery] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleSearch = (location) => {
    onSearch(location);
    setQuery(location);
    setShowSuggestions(false);
  };

  const handleInputChange = (e) => {
    setQuery(e?.target?.value);
    setShowSuggestions(e?.target?.value?.length > 0);
  };

  return (
    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 w-96 max-w-full z-[400]">
      <div className="relative">
        <div className="flex gap-2">
          <div className="flex-1 relative">
            <Input
              type="search"
              placeholder="Search zones, trails, or coordinates..."
              value={query}
              onChange={handleInputChange}
              onFocus={() => setShowSuggestions(query?.length > 0)}
              className="pr-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              color="var(--color-muted-foreground)" 
              className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
            />
          </div>
          <Button variant="default" iconName="Navigation" onClick={() => handleSearch(query)}>
            Locate
          </Button>
        </div>
        
        {showSuggestions && suggestions && suggestions?.length > 0 && (
          <div className="absolute top-full mt-2 w-full bg-card rounded-lg shadow-conservation-lg border border-border max-h-64 overflow-y-auto">
            {suggestions?.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSearch(suggestion?.name)}
                className="w-full p-3 flex items-center gap-3 hover:bg-muted/50 transition-colors text-left border-b border-border last:border-b-0"
              >
                <Icon name={suggestion?.icon} size={18} color="var(--color-primary)" />
                <div className="flex-1">
                  <div className="font-medium text-foreground">{suggestion?.name}</div>
                  <div className="text-xs text-muted-foreground">{suggestion?.type} • {suggestion?.coordinates}</div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchLocation;